/*
 * @Descripttion: 
 * @version: 
 * @Author: bbq
 * @Date: 2020-08-17 09:56:40
 * @LastEditors: bbq
 * @LastEditTime: 2020-11-07 15:47:22
 */
import React, { Component } from "react";
import { getSysFieldid } from '@platform/api';
require("./TabsControl.less");

class TabsControl extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentIndex: this.props.defaultKey,
        };
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        if (newProps.defaultKey != this.props.defaultKey) {
            this.setState({
                currentIndex: newProps.defaultKey,
            });
        }
    }

    tab_title_index(index) {
        return index === this.state.currentIndex
            ? "tab_title active"
            : "tab_title";
    }

    render() {
        return (
            <div className="lightapp-component-TabLi" fieldid={getSysFieldid('tabs-area')}>
                {React.Children.map(this.props.children, (element, index) => {
                    return (
                        <React.Fragment>
                            <div
                                onClick={() => {
                                    this.setState(
                                        { currentIndex: index },
                                        element.props.clickFun,
                                    );
                                }}
                                className={this.tab_title_index(index)}
                            >
                                <p>{element.props.children}</p>
                                <p />
                            </div>
                            <span className="splitter"></span>
                        </React.Fragment>
                    );
                })}
            </div>
        );
    }
}

export default TabsControl;
